import { useLocation } from 'react-router-dom';
import { PATH } from '../../constants';
import { NavigationLink } from './navigationLink';

export function isActiveLink(currentPath: string, linkPath: string) {
  // TODO: this methods needs work
  // 1. case when the path is "/path/*"
  // 2. case when the path is "/path?*"
  // also not the best way to check

  if (linkPath.length > 1) {
    if (currentPath === '/' + linkPath) return true;
  } else {
    if (currentPath === linkPath) return true;
  }
  return false;
}

export default function DesktopNavigation() {
  const { pathname } = useLocation();

  return (
    <nav className="flex flex-col mt-1">
      <NavigationLink
        active={isActiveLink(pathname, PATH.HOME)}
        href={`${PATH.HOME}`}
        text="home"
        icon="home"
      />
      <NavigationLink
        active={isActiveLink(pathname, PATH.DISCOVER)}
        href={`/${PATH.DISCOVER}`}
        text="discover"
        icon="discover"
      />
      <NavigationLink
        active={isActiveLink(pathname, PATH.CHANNELS)}
        href={`/${PATH.CHANNELS}`} // todo: always go to most recent space
        text="channels"
        icon="spaces"
      />
      <NavigationLink
        active={isActiveLink(pathname, PATH.BOOKMARKS)}
        href={`/${PATH.BOOKMARKS}`}
        text="bookmarks"
        icon="saved"
      />
      <NavigationLink
        active={isActiveLink(pathname, PATH.EVENTS)}
        href={`/${PATH.EVENTS}`}
        text="events"
        icon="events"
      />
      <NavigationLink
        active={isActiveLink(pathname, PATH.RELEASES)}
        href={`/${PATH.RELEASES}`}
        text="releases"
        icon="releases"
      />
      <NavigationLink
        active={isActiveLink(pathname, PATH.SUBSCRIPTIONS)}
        href={`/${PATH.SUBSCRIPTIONS}`}
        text="subscriptions"
        icon="subscriptions"
      />
    </nav>
  );
}
